/* eslint eqeqeq: 0 */
import { languageService } from "../../../Language/language.service";

export const setActiveStateOfFixedDatesFilter = (filters, dateFilterName) => {
  filters &&
    filters.forEach(element => {
      if (languageService(element.text) == dateFilterName) {
        element.state = true;
      }
    });
};



// WEBPACK FOOTER //
// ./src/components/JourneyPlan/HelperFunctions/dateRelatedFunctions.js